import { InjectionToken } from "@angular/core";
import { ContentProviderAdapter } from "./content-provider.interface";

/**
 * Injection token for Content Provider adapter
 */
export const CONTENT_PROVIDER = new InjectionToken<ContentProviderAdapter>(
  "CONTENT_PROVIDER"
);
